import React from 'react';
import {
    Container as MuiContainer
} from '@mui/material';

const Container: React.FC = ({ children }) => {
    return (
        <MuiContainer
            maxWidth="xl"
            sx={{
                mt: { xs: 2, md: 4 },
                mb: { xs: 2, md: 4 },
                px: { xs: 1, sm: 2, md: 3 }
            }}
        >
            {children}
        </MuiContainer>
    );
};

export default Container;
